var React = require('react');

function Arrows (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"22.5874","y":"19.7588","width":"4","height":"27.9435","transform":"rotate(135 22.5874 19.7588)","fill":"#9FAEE2","key":0}),React.createElement("rect",{"x":"19.7593","y":"16.999","width":"4","height":"27.9435","transform":"rotate(45 19.7593 16.999)","fill":"#9FAEE2","key":1}),React.createElement("rect",{"x":"37.5874","y":"19.7588","width":"4","height":"27.9435","transform":"rotate(135 37.5874 19.7588)","fill":"#9FAEE2","key":2}),React.createElement("rect",{"x":"34.7593","y":"16.999","width":"4","height":"27.9435","transform":"rotate(45 34.7593 16.999)","fill":"#9FAEE2","key":3})]);
}

Arrows.defaultProps = {"width":"38","height":"40","viewBox":"0 0 38 40","fill":"none"};

module.exports = Arrows;

Arrows.default = Arrows;
